import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import { getOrgId } from "utils/storage";

import Paths from "./paths";
import * as Types from "./types";

export const orgChartListService = () =>
  RestAPIClient.call<Types.OrgChartListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
    },
  });

export const orgChartListEmployeeService = ({
  departmentId,
}: {
  departmentId: number;
}) =>
  RestAPIClient.call<Types.OrgChartListEmployeeResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListEmployee.replace("{OrgId}", getOrgId()).replace(
      "{departmentId}",
      departmentId.toString()
    ),
    config: {
      requireAuthentication: true,
    },
  });
